module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "dylan"
    }
  }, [_c('path', {
    attrs: {
      "id": "dylan_left_hand",
      "fill": "#F0CDB8",
      "d": "M3831.7 350.72c.16 1.36 1.2 2.02 2.3 3.52 1.26 1.76 1.5 5.12 3 7.82-.27.7-2.46-.33-3-1.42-.54-1.1-.96-2-1.13-2.26-.18-.27-.54-.22-.62.06-.08.3.7 10.18.54 10.7-.2.5-1.44.64-1.7.16-.28-.48-1.1-8.3-1.23-8.5-.13-.18-.4-.05-.5.07-.1.12 1 8.44.85 8.76-.15.33-1.45.4-1.62.17-.17-.24-1.12-8.55-1.28-8.73-.17-.17-.45-.12-.55.06-.1.18 1.1 8.15.93 8.52-.16.36-1.42.5-1.57.16-.16-.33-1.3-8.36-1.42-8.46-.13-.1-.3-.08-.4.04-.1.12.43 6.14.27 6.5-.17.34-1.1.5-1.3.12-.18-.4-1.1-15.12-1.2-15.93-.37-2.7.96-5.7 4.26-6.04 3.3-.33 5.03 1.78 5.37 4.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_arm_bottom",
      "fill": "#353535",
      "d": "M3824.43 318.04c-3.94.4-6.8 3.94-6.4 7.87l.05.3 3.8 25.76c.2 1.27 1.35 2.16 2.62 2.03l7.36-.78c1.27-.14 2.22-1.25 2.14-2.52l-1.65-26c-.25-3.94-3.66-6.93-7.62-6.7l-.3.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_leftt_arm_top",
      "fill": "#353535",
      "d": "M3821.74 291c-3.92.36-6.82 3.88-6.48 7.87l2.27 26.53c.34 4 3.8 6.94 7.73 6.6 3.92-.36 6.82-3.88 6.48-7.87l-2.27-26.53c-.34-4-3.8-6.94-7.73-6.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_shoe_4",
      "fill": "#353535",
      "d": "M3823.97 434H3811v14h28c-.23-4-2.17-6.34-5.8-7-3.64-.66-6.72-3-9.23-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_shoe_3",
      "fill": "#787B78",
      "d": "M3811 446v2h28c-.1-.92-.18-1.6-.27-2H3811z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_left_shoe_2",
      "fill": "#787B78",
      "points": "3829 440.575943 3827.97303 442 3824 439.088172 3825.26134 438",
      "transform": "matrix(-1 0 0 1 7653 0)"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_left_shoe_1",
      "fill": "#787B78",
      "points": "3826 438.4 3825.01991 440 3821 437.460322 3822.02091 436",
      "transform": "matrix(-1 0 0 1 7647 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_leg_bottom",
      "fill": "#ABAFAB",
      "d": "M3817.5 379c-5.25 0-9.5 4.25-9.5 9.5V434h19v-45.5c0-5.25-4.25-9.5-9.5-9.5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_left_leg_top",
      "width": "19",
      "height": "60",
      "x": "3808",
      "y": "338",
      "fill": "#ABAFAB",
      "transform": "matrix(-1 0 0 1 7635 0)",
      "rx": "9.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_shoe_4",
      "fill": "#3D3D3D",
      "d": "M3802.97 434H3790v14h28c-.23-4-2.17-6.34-5.8-7-3.64-.66-6.72-3-9.23-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_shoe_3",
      "fill": "#7C7F7C",
      "d": "M3790 446v2h28c-.1-.92-.18-1.6-.27-2H3790z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_right_shoe_2",
      "fill": "#7C7F7C",
      "points": "3807 440.575943 3805.97303 442 3802 439.088172 3803.26134 438",
      "transform": "matrix(-1 0 0 1 7609 0)"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "dylan_right_shoe_1",
      "fill": "#7C7F7C",
      "points": "3805 438.4 3804.01991 440 3800 437.460322 3801.02091 436",
      "transform": "matrix(-1 0 0 1 7605 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_leg_bottom",
      "fill": "#ABAFAB",
      "d": "M3796.5 379c-5.25 0-9.5 4.25-9.5 9.5V434h19v-45.5c0-5.25-4.25-9.5-9.5-9.5z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_right_leg_top",
      "width": "19",
      "height": "60",
      "x": "3787",
      "y": "338",
      "fill": "#ABAFAB",
      "transform": "matrix(-1 0 0 1 7593 0)",
      "rx": "9.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hip",
      "fill": "#ABAFAB",
      "d": "M3827 329h-41v5.5c0 11.32 9.18 20.5 20.5 20.5s20.5-9.18 20.5-20.5V329z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_bag_3",
      "width": "43",
      "height": "60",
      "x": "3777",
      "y": "283",
      "fill": "#5B7046",
      "transform": "matrix(-1 0 0 1 7597 0)",
      "rx": "21.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hoodie_2",
      "fill": "#BCC1BC",
      "d": "M3824.22 287.88c-4.86-6.26-26.87-6.48-32.16-.77-12.6 13.58-4.4 38.76-7.4 44.43-2.98 5.67-1.3 9.36 0 11.46 5.63 9 37.2 11.92 44.1.8 1.5-2.43 2.1-9.85-.93-15.26-3.03-5.4-1.5-37.94-3.6-40.66z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hoodie_1",
      "fill": "#353535",
      "d": "M3822.9 282.98c-.95-8.57-25.32-10.02-26.77 0-1.45 10.02 9.48 12.77 15.75 7.13 7.1 3.18 11.94 1.45 11-7.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_bag_2",
      "fill": "#778F5F",
      "d": "M3793.06 287c-2.48.03-5.7 2.38-4.94 4.9 13.63.07 11.1 18.13 7.54 31.02 0 .9.18 4.03 0 5.08 10.26-9.6 12.85-36.78-2.6-41z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_bag_1",
      "fill": "#778F5F",
      "d": "M3828.35 292.74c-.5-3.35-3.05-5.5-5.35-5.74 2.2 12.1 2.68 26.9 3.83 38 1.63-12.76 3.04-22.1 1.52-32.26z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_hand",
      "fill": "#F0CDB8",
      "d": "M3794.05 351.2c0 1.34.94 2.1 1.85 3.7 1.05 1.88.93 5.23 2.1 8.06-.34.65-2.36-.58-2.77-1.7-.4-1.15-.72-2.08-.86-2.37-.14-.3-.5-.28-.6 0-.12.27-.4 10.16-.62 10.64-.22.5-1.45.5-1.67 0-.2-.5-.18-8.32-.28-8.53-.1-.2-.38-.1-.5 0-.1.12.1 8.48-.1 8.8-.18.3-1.45.24-1.6 0-.13-.27-.18-8.6-.32-8.8-.13-.18-.42-.16-.53 0-.12.18.2 8.2 0 8.54-.2.35-1.43.35-1.55 0-.1-.35-.36-8.42-.48-8.53-.12-.1-.28-.1-.4 0-.1.1-.23 6.14-.43 6.47-.2.33-1.14.4-1.28 0-.14-.4.52-15.1.5-15.9-.06-2.73 1.56-5.57 4.8-5.57 3.25 0 4.7 2.27 4.73 5.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_arm_bottom",
      "fill": "#353535",
      "d": "M3790 318c-3.87 0-7 3.14-7 7v.3l.97 23.9c.1 2.68 2.3 4.8 5 4.8h2.07c2.68 0 4.88-2.12 5-4.8l.96-23.9c.16-3.88-2.85-7.14-6.72-7.3h-.28z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "dylan_right_arm_top",
      "width": "14",
      "height": "41",
      "x": "3783",
      "y": "291",
      "fill": "#353535",
      "transform": "matrix(-1 0 0 1 7580 0)",
      "rx": "7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_neck",
      "fill": "#E5BDA6",
      "d": "M3814.5 280.54c-.4 2.6-.6 4.4.5 5.84-.28.54-.7 2.18-2.96 2.54-3.1.5-6.48-1.3-7.04-2.54 1-1.46 1.1-2.94.5-5.84.74-2.1 7.97-2.02 9 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_face",
      "fill": "#F0CDB8",
      "fill-rule": "nonzero",
      "d": "M3792.75 264.05c-1-.6-2.46-1.35-4.1 0-1.4 1.15-.35 5.68 1.55 8.2 1.88 2.48 4.93 3 6.13 2.04 2.8 6.1 5.73 8.7 13.3 8.7 10.67 0 14.37.68 14.37-21 0-15.32-4.12-21-14.37-21-9.2-.05-19.4 4.8-16.88 23.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_mouth_bottom",
      "fill": "#DFB39B",
      "d": "M3814.8 277h-7.66c-.8 0 2.05 1 4.6 1 2.56 0 3.77-1 3.06-1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_mouth_top",
      "fill": "#D3A185",
      "d": "M3815.75 277h-9.58c-1 0 2.56-2 5.76-2 3.2 0 4.7 2 3.82 2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_ear",
      "fill": "#E5BDA6",
      "d": "M3792.92 268.28c-.96-1.97-2.46-3.8-4.3-3.15-1.83.65.52 7.88 5.38 7.87-.56-.34-2.1-1.92-2.15-3.15-.05-1.23.36-1.85 1.07-1.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_nose",
      "fill": "#DFB39B",
      "d": "M3812.9 263.77c0-.98-2.54-1.07-2.54 0 0 1.06-.8 6.62 0 7.6.82 1 3.2.66 3.58 0 .37-.65-1.04-6.62-1.04-7.6z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_right_cheek",
      "cx": "3802",
      "cy": "272",
      "r": "3",
      "fill": "#EDC7B2",
      "transform": "matrix(-1 0 0 1 7604 0)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_left_cheek",
      "cx": "3819",
      "cy": "272",
      "r": "3",
      "fill": "#EDC7B2",
      "transform": "matrix(-1 0 0 1 7638 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_eye_whites",
      "fill": "#FFF",
      "d": "M3807 264.36c-1.3-3.94-7.13-4.54-8-1.13 0 4.6 7.05 5 8 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_right_pupil",
      "cx": "3802",
      "cy": "264",
      "r": "2",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 7604 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_eye_whites",
      "fill": "#FFF",
      "d": "M3815 264.36c1.3-3.94 7.13-4.54 8-1.13 0 4.6-7.05 5-8 1.13z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "dylan_left_pupil",
      "cx": "3818",
      "cy": "264",
      "r": "2",
      "fill": "#3C2D20",
      "transform": "matrix(-1 0 0 1 7636 0)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_left_brow",
      "fill": "#33261A",
      "d": "M3814.02 260.05c.27-1.36 8.8-1.38 8.97-.17.16 1.22-1.63.64-3.98.87-2.35.23-5.27.66-5-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_right_brow",
      "fill": "#33261A",
      "d": "M3806.98 260.05c-.27-1.36-8.8-1.38-8.97-.17-.16 1.22 1.63.64 3.98.87 2.35.23 5.27.66 5-.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hair",
      "fill": "#7F9568",
      "d": "M3790.38 263.03c3.74.8 4.7 7.98 5.2 8.5.5.53 1.82.72 1.78 0-.03-.7-1.77-8.5.64-15.53-1 .1-3.67 1.13-8 3.07l.38 3.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hat_2",
      "fill": "#1C1C1C",
      "d": "M3809.76 240c-14.4.62-19.9 1.08-19.76 20 7.6-4.3 28.98-4.58 34-2.4-.14-10.72-5.2-17.97-14.24-17.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "dylan_hat_1",
      "fill": "#353535",
      "d": "M3828.74 255.8c-6.72-5.7-25.54-4.4-30.82.1-1.72 1.45-.83 2.46 1 1.98 3.64-.97 23-1.46 28.72-.08 2.18.53 3.45 0 1.1-2z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2343ea4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/dylan.vue
// module id = 677
// module chunks = 1